var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCallYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.944 511.944",
    style: {
      enableBackground: "new 0 0 511.944 511.944"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FDD900",
    d: "M349.388,310.333c-2.813-2.813-6.628-4.394-10.606-4.394s-7.794,1.581-10.606,4.394   c-10.548,10.548-43.472,43.472-55.513,55.512c-52.367-31.227-96.054-74.913-127.279-127.279l55.513-55.513   c2.813-2.813,4.394-6.628,4.394-10.606s-1.58-7.793-4.394-10.606L94.829,55.774c-5.857-5.857-15.355-5.858-21.213,0L31.267,98.121   c-0.026,0.026-0.055,0.047-0.081,0.073s-0.048,0.055-0.074,0.082l-0.225,0.225c-31.002,31-39.631,78.207-21.473,117.467   c24.296,52.528,55.646,100.866,93.183,143.669c53.835,61.39,119.134,109.69,194.082,143.561   c38.354,17.333,84.787,8.4,115.519-22.33l43.256-43.256c5.858-5.857,5.858-15.355,0-21.213L349.388,310.333z M84.223,87.594   l84.854,84.853l-21.22,21.22l-84.848-84.86L84.223,87.594z M309.034,475.86C156.1,406.747,76.494,289.534,36.643,203.375   c-10.86-23.48-8.174-51.016,6.156-72.351l83.845,83.856l-10.6,10.6c-4.735,4.735-5.759,12.037-2.506,17.891   c36.055,64.9,89.418,118.263,154.319,154.32c5.855,3.252,13.156,2.23,17.892-2.506l10.606-10.606l83.956,83.967   C359.2,483.125,332.01,486.245,309.034,475.86z M402.414,448.225l-84.847-84.858l21.214-21.213l84.853,84.853L402.414,448.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD900",
    d: "M376.941,0c-74.439,0-135,60.561-135,135c0,22.793,5.975,45.305,17.341,65.544l-16.571,49.712   c-1.797,5.39-0.394,11.333,3.624,15.35c4.039,4.039,9.989,5.412,15.35,3.624l49.713-16.571c20.239,11.366,42.75,17.34,65.544,17.34   c74.439,0,135-60.561,135-135S451.38,0,376.941,0z M376.941,240c-19.481,0-38.762-5.679-55.756-16.422   c-2.427-1.534-5.21-2.321-8.017-2.321c-1.594,0-3.195,0.254-4.742,0.77l-27.768,9.256l9.256-27.767   c1.423-4.271,0.854-8.954-1.552-12.759c-10.743-16.995-16.422-36.276-16.422-55.757c0-57.897,47.103-105,105-105   s105,47.103,105,105S434.838,240,376.941,240z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD900",
    cx: 316.941,
    cy: 135,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD900",
    cx: 376.941,
    cy: 135,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD900",
    cx: 436.941,
    cy: 135,
    r: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallYellow);
export default __webpack_public_path__ + "static/media/phone-call-yellow.6e795a0a3b3bdde5e8df3f43b543755d.svg";
export { ForwardRef as ReactComponent };